import { useContext } from 'react'
import ReservationContext from '../context/ReservationProvider';

const useReservation = () => {
    return useContext(ReservationContext);
}

export default useReservation